import styled from 'styled-components';
import SellIconDark from '../../assets/images/sell-icon.svg';
import SellIconLight from '../../assets/images/sell-icon-light.svg';

const SellIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${SellIconDark}") no-repeat left center`
      : `url("${SellIconLight}") no-repeat left center`};
  background-size: 23px 21px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 21px;
  width: 23px;
`;

export default SellIcon;
